/**
 * created by yxy
 * 资源库路由
 */
import Resource from "../view/Resource/Resource"
import Story from "../view/Story/Story"
import DetailPage from '../components/DetailPage'
import MyShare from '../view/Share/MyShare'
import ShareWithMe from '../view/Share/ShareWithMe'
import Collection from '../view/Collection/Collection'
import Download from '../view/Download/Download'
import Label from '../view/Label/label'
import MyUpload from '../view/MyUpload/MyUpload'
import Recycle from '../view/Recycle/Recycle'
import Authorization  from '../view/Authorization/Authorization'
import Application from '../view/Application/Application'
import PathConfig from "../view/pathConfig";
import schoolResource from '../view/SchoolResource/SchoolResource'
import UnitResources from '../view/SchoolResource/UnitResources'
import ComposeFile from '../view/ResourcesFile/ComposeFile'
import RelationshipMap from '../components/detailPageRight/RelationshipMap'
import ResourceIndex from '../view/resourceIndex/index'
import FaceRecognition from '../view/faceRecognition/faceRecognition'
import TransferList from '../view/TransferList/transferList';
import Downloads from "../view/resourceStatistics/downloads/Downloads";
import ResourceDownloadRecord from "../view/resourceStatistics/resourceDownloadRecord/ResourceDownloadRecord";
import UploadStatistics from "../view/resourceStatistics/uploadStatistics/UploadStatistics";

export const  ResourceRouter =[
    {
        path: "/view/Resource/resource/:resource",// 全部 resource =1 ,公共资源 resource =2,单位资源 resource =3,个人资源 resource =4
        componentTitle: "全部资源",
        component: Resource
    },
    {
        path: "/view/Resource/resource/:indexName/:authType",// 图片视频音频其他 authType 用来区分全部、公共资源、单位资源、个人资源 indexName 用来区分文件类型
        componentTitle: "个人资源图片视频音频其他",
        component: ComposeFile
    },

    {
        path: "/view/story/:story",// 稿件库
        component: Story
    },
    {
        path: "/view/story/detailPage",// 详情页
        component: DetailPage
    },
    {
        path: "/view/share/myShare",//我的分享
        component: MyShare
    },
    {
        path: "/view/share/ShareWithMe", // 分享给我
        component: ShareWithMe
    },
    {
        path: "/view/collection/collection", // 我的收藏
        component: Collection
    },
    {
        path: "/view/downLoad/downLoad", // 我的下载
        component: Download
    },
    {
        path: "/view/label/label", // 我的标签
        component: Label
    },
    {
        path: "/view/myUpload/myUpload", // 我的上传
        component: MyUpload
    },
    {
        path: "/view/Resource/recycle/:recycle", // 全部资源回收站  recycle  1
        componentTitle: "全部资源回收站",
        component: Recycle
    },
    {
        path: "/view/Resource/recycle/:recycle", // 单位资源回收站   recycle  2
        componentTitle: "单位资源回收站",
        component: Recycle
    },
    {
        path: "/view/Resource/recycle/:recycle", // 个人资源回收站 recycle  3
        componentTitle: "个人资源回收站",
        component: Recycle
    },
    {
        path: "/view/authorization/authorization", // 权限设置
        component: Authorization
    },
    {
        path: "/view/application/application", // 资源申请
        component: Application
    },
    {
        path: "/view/path/config", // 路径
        component: PathConfig,
        componentProps:{sysConfigKeyParamsVal : "pathConfig"}
    },
    {
        path: "/view/schoolResource/schoolResource/:Resources", // 校级资源管理
        componentTitle: "校级资源管理",
        component: schoolResource
    },
    {
        path: "/view/UnitResources/UnitResources/:Resources", // 单位资源管理
        componentTitle: "单位资源管理",
        component: UnitResources
    },
    {
        path: "/view/RelationshipMap", // 单位资源管理
        componentTitle: "相关图谱",
        component: RelationshipMap
    },
    {
        path: "/view/resource/index", // 单位资源管理
        componentTitle: "首页",
        component: ResourceIndex,
    },
    {
        path: "/view/resource/faceRecognition", // 人脸识别
        componentTitle: "人脸识别",
        component: FaceRecognition,
    },
    {
        path: "/view/resource/transferList", // 人脸识别
        componentTitle: "人脸识别",
        component: TransferList,
    },
    {
        path: "/view/resourceStatistics/Downloads", // 资源统计-下载次数
        component: Downloads
    },
    {
        path: "/view/resourceStatistics/ResourceDownloadRecord", // 资源统计-资源下载记录
        component: ResourceDownloadRecord
    },
    {
        path: "/view/resourceStatistics/UploadStatistics", // 资源统计-上传文件统计
        component: UploadStatistics
    },

];

